import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner, Form } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { getHydrantListById, saveHydrantData, updateHydrantData } from "../../redux/actions/HydrantActions";
import FormInput from "../../Components/FormInput";
import { useNavigate, useParams } from "react-router-dom";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import LeafletSingleMap from "../../Components/LeafletSingleMap";
import { getAddressByLatLng, getAllUsertypeUserList,getAllUsersRoleWiseList, getMasterCameraList } from "../../redux/actions/MasterActions";
import Preloader from "../../Components/Preloader";
import { getVolveConfigurationList } from "../../redux/actions/MasterActions";

const Dashboard = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
    const [roleCode,setroleCode]=useState("JUNIOR_ENGINEER");
  
  const [formData, setFormData] = useState({
   latitude:0,

  longitude:0,
  });
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    hydrantReducer: {
      loadingHydrant,
      errorsHydrant,
      hydrantById,
      hydrantLists,
      changedHydrantStatus,
    },
    masterReducer: {
      reverseAddressList,
      masterUsertypeUserLists,
      masterUsersRoleWiseLists,
      masterVolveConfigurationLists,
      masterCameraLists,
    }
  } = useSelector((state) => state);


  const [validated, setValidated] = useState(false);
    const [fieldErrors, setFieldErrors] = useState({});
    useEffect(() => {
      if (id) {
        dispatch(getHydrantListById(auth?.accessToken, id));
      }
    }, [auth?.accessToken, id]);

  useEffect(() => {
    if (hydrantById && Object.keys(hydrantById).length > 0) {
      setFormData({
        "name": hydrantById?.name,
        "latitude": hydrantById?.latitude,
        "longitude": hydrantById?.longitude,
        "address": hydrantById?.address,
        "jenId": hydrantById?.jen?.id,
        "hydrantId": hydrantById?.hydrantId?.id,
        "cameraId": hydrantById?.camera?.id,
        "status": hydrantById?.status,
      });
    }
  }, [hydrantById]);
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if (id) {
        const updatedpayloaddata={ id: id,
        "name": formData?.name,
          "latitude": Number(formData?.latitude),
          "longitude": Number(formData?.longitude),
          "address": formData?.address,
          "jenId": formData?.jenId,
          "hydrantId": formData?.hydrantId || "",
          "cameraId": formData?.cameraId || "",
          "status":formData?.status,
      }
      dispatch(updateHydrantData(auth?.accessToken, updatedpayloaddata, id));
    }
    else {
      const payloaddata={
        "name": formData?.name,
          "latitude": Number(formData?.latitude),
          "longitude": Number(formData?.longitude),
          "address": formData?.address,
          "jenId": formData?.jenId,
          "hydrantId": formData?.hydrantId || "",
          "cameraId": formData?.cameraId || "",
          "status":formData?.status,
      }
      dispatch(saveHydrantData(auth?.accessToken, payloaddata));
    }
  };
 useEffect(() => {
    if (auth?.accessToken && roleCode) {
      dispatch(getAllUsersRoleWiseList(auth?.accessToken, roleCode));
    }
  }, [auth?.accessToken, roleCode, dispatch]);
  useEffect(()=>{
    if(auth?.accessToken){
      dispatch(getMasterCameraList(auth?.accessToken));
    }
  }, [auth?.accessToken, dispatch]);

  useEffect(() => {
    if (auth?.accessToken) {
      dispatch(getVolveConfigurationList(auth?.accessToken));
    }
  }, [auth?.accessToken, dispatch]);

  useEffect(() => {
    if (!id) {
      setFormData({
        latitude: 0,
        longitude: 0,
      });
    }
    dispatch({ type: 'RESET_DELETE_HYDRANTS_STATUS' });
  }, [id, dispatch]);


  useEffect(() => {
    //dispatch(getAllUsertypeUserList(auth?.accessToken, 13, ''));
    if (id) {
      dispatch(getHydrantListById(auth?.accessToken, id));
    }
  }, [auth, id]);

  useEffect(() => {
    if (id) {
      if (hydrantLists && Object.keys(hydrantLists).length > 0) {
        setFormData({
          "name": hydrantLists?.name,
          "latitude": hydrantLists?.latitude,
          "longitude": hydrantLists?.longitude,
          "address": hydrantLists?.address,
          "jenId": hydrantLists?.jen?.id,
          "hydrantId": hydrantLists?.hydrantId?.id,
          "cameraId": hydrantLists?.camera?.id,
          "status":hydrantLists?.status,
        });
      }
    }

  }, [hydrantLists])

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      if (errors?.status === 401) {
        dispatch(logout());
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  }, [errors, dispatch, navigate]);

  useEffect(() => {
    if (errorsHydrant && Object.keys(errorsHydrant).length > 0) {
      if (errorsHydrant?.status === 409) {
        swal.fire({
          show: true,
          title: "Oops!",
          text: errorsHydrant?.data?.message,
          icon: "error",
          showConfirmButton: false,
          timer: 1500
        });
        dispatch({ type: 'RESET_DELETE_HYDRANTS_STATUS' });
      }
      else if (errorsHydrant?.status === 400) {
        if (errorsHydrant?.data?.errors && Array.isArray(errorsHydrant.data.errors)) {
          const transformedErrors = {};
          errorsHydrant.data.errors.forEach(error => {
            if (error.field && error.message) {
              transformedErrors[error.field] = error.message;
            }
          });
          setFieldErrors(transformedErrors);
        }
      }
      else {
        dispatch({ type: 'RESET_DELETE_HYDRANTS_STATUS' });
      }
    }
  }, [errorsHydrant, dispatch]);

  useEffect(() => {
    if (changedHydrantStatus?.message) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedHydrantStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_HYDRANTS_STATUS' });
      navigate(-1);
    }
  }, [changedHydrantStatus, dispatch, navigate]);

  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const inputHandlerCaps = (e) => {
    const { value, name } = e.target;
    const processedValue = value.replace(/\s+/g, '').toUpperCase(); // Remove spaces and convert to uppercase
    setFormData({ ...formData, [name]: processedValue });
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const selectHandler = (selectedData, name) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData
    }));
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors?.data?.state_code ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errors?.data?.state_code ? 'red' : base.borderColor,
      }
    }),
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log(position);
          setFormData((prevFormData) => ({
            ...prevFormData,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          }));
        },
        (error) => {
          // setError(error.message);
        }
      );
    } else {
      //setError('Geolocation is not supported by this browser.');
    }
  }, []);

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      address: reverseAddressList?.label,
    }));
  }, [reverseAddressList])

  useEffect(() => { 
    console.log('fieldErrors', fieldErrors);
  },[fieldErrors]);

  useEffect(() => {
      setFieldErrors({});
      
  },[navigate]);
  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Hydrant"), path: "Hydrant" },
          { label: id ? t("Update Hydrant") : t("Add Hydrant"), path: "/Add-Hydrant", active: true },
        ]}
        title={id ? t("Update Hydrant") : t("Add Hydrant")}
      />
      <Row>
        <Col lg={6}>
          <Card>
            <Card.Body>
              <div style={{ position: "relative", overflow: "hidden", height: "500px" }}>
                <LeafletSingleMap
                  mapHeight={"600px"}
                  center={[formData.latitude || 0.00, formData.longitude || 0.00]}
                  zoom={15}
                  setFormData={setFormData}
                />
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={6}>
          <Card>
            <Card.Body>
              {errorsHydrant?.data?.message && (
                <div className="alert alert-danger">
                  {errorsHydrant?.data?.message}
                </div>
              )}

              <Row>
                {/* <Col lg={12}>
                  <FormInput
                    label={t("Hydant Id")}
                    type="text"
                    errors={fieldErrors}
                    value={formData?.hydrantId}
                    name="hydrantId"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col> */}
                  <Col lg={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Hydrant Name")}</Form.Label>
                    <Select
                     className={fieldErrors?.hydrantId ? "border-danger" : ""}
                      options={masterVolveConfigurationLists || ""}
                      values={masterVolveConfigurationLists?.filter(data => data?.mqttConfigId === formData?.hydrantId) || []}
                      name="hydrantId"
                      labelField="name"
                      valueField="mqttConfigId"
                      onChange={(selectedData) => selectHandler(selectedData[0]?.mqttConfigId, "hydrantId")}
                      styles={customSelectStyles}
                    />
                    {fieldErrors?.hydrantId && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.hydrantId}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Camera Name")}</Form.Label>
                    <Select
                     className={fieldErrors?.cameraId ? "border-danger" : ""}
                      options={masterCameraLists || ""}
                      values={masterCameraLists?.filter(data => data?.cameraId === formData?.cameraId) || []}
                      name="cameraId"
                      labelField="cameraName"
                      valueField="cameraId"
                      onChange={(selectedData) => selectHandler(selectedData[0]?.cameraId, "cameraId")}
                      styles={customSelectStyles}
                    />
                    {fieldErrors?.cameraId && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.cameraId}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={12}>
                  <FormInput
                    label={t("Name")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.name}
                    name="name"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={6}>
                  <FormInput
                    label={t("Latitude")}
                    type="number"
                    errors={fieldErrors}
                    value={formData?.latitude}
                    name="latitude"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={6}>
                  <FormInput
                    label={t("Longitude")}
                    type="number"
                    errors={fieldErrors}
                    value={formData?.longitude}
                    name="longitude"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={12}>
                  <FormInput
                    label={t("Address")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.address}
                    name="address"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("J.E.N.")}</Form.Label>
                    <Select
                     className={fieldErrors?.jenId ? "border-danger" : ""}
                      options={masterUsersRoleWiseLists}
                      values={masterUsersRoleWiseLists?.filter(data => data?.id === formData?.jenId)}
                      name="jenId"
                      labelField={"name"}
                      valueField={"id"}
                      onChange={(selectedData) => selectHandler(selectedData[0]?.id, "jenId")}
                      styles={customSelectStyles}
                    />
                    {fieldErrors?.jenId && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.jenId}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <div className="d-flex justify-content-center">
                {loading ?
                  <Button color="primary" disabled>
                    <Spinner
                      className="spinner-border-sm me-1"
                      tag="span"
                      color="white"
                    />
                    Please wait ...
                  </Button>
                  :
                  <Button type="button" onClick={handleSubmit} disabled={loading}>
                    Submit
                  </Button>
                }
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loadingHydrant && (<Preloader />)}
    </>
  );
};

export default Dashboard;
